module.exports = "/images/10K-RG.webp?64509ccd0d0abacab58552677ead9c64";